import { Globe } from 'lucide-react-native';
import { ActivityIndicator, Pressable, StyleSheet } from 'react-native';
import { HStack, Text } from '../../../components/primitives';
import { useTranslation } from '../../../contexts/TranslationContext';
import { colors } from '../../../theme/colors';
import { tokens } from '../../../theme/tokens';

interface WebSearchButtonProps {
  onPress: () => void;
  loading?: boolean;
  disabled?: boolean;
}

export function WebSearchButton({ onPress, loading, disabled }: WebSearchButtonProps) {
  const { t } = useTranslation();
  const isDisabled = disabled || loading;

  return (
    <Pressable
      onPress={onPress}
      disabled={isDisabled}
      testID="lead_web_search_button"
      accessibilityRole="button"
      accessibilityLabel={t('leads.webSearch.searchContact')}
      style={({ pressed }) => [
        styles.button,
        pressed && !isDisabled && styles.pressed,
        isDisabled && styles.disabled,
      ]}
    >
      <HStack spacing="sm" style={{ alignItems: 'center', justifyContent: 'center' }}>
        {loading ? (
          <ActivityIndicator size="small" color={colors.primary[400]} />
        ) : (
          <Globe size={15} color={colors.primary[400]} strokeWidth={2} />
        )}
        <Text variant="bodySmall" color={colors.primary[300]} weight="semibold">
          {t('leads.webSearch.searchContact')}
        </Text>
      </HStack>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  button: {
    backgroundColor: colors.primary.muted,
    borderWidth: 1,
    borderColor: colors.primary.subtle,
    borderRadius: tokens.radius.md,
    paddingHorizontal: 14,
    paddingVertical: 10,
    alignItems: 'center',
  },
  pressed: {
    backgroundColor: colors.primary.subtle,
  },
  disabled: {
    opacity: 0.5,
  },
});
